module.exports = __webpack_public_path__ + "static/media/10x_Logo_slide_out.452870bb.svg";